import Vue from 'vue'
import Vuex from 'vuex'
import mobileMenuModule from '@/store/modules/mobileMenu'
import onlineBooking from '@/store/modules/onlineBooking'
import SecurityModule from '@/store/modules/security'
import research from '@/store/modules/research'
import messages from '@/store/modules/messages'
import news from '@/store/modules/news'
import data from '@/store/modules/data'
import adminRoutes from '@/store/modules/adminRoutes'
import generic from '@/store/modules/generic'
import currentPage from '@/store/modules/currentPage'

Vue.use(Vuex)

const version = {
  state: '20201201' // version du schema
}

export default new Vuex.Store({
  modules: {
    mobileMenu: mobileMenuModule,
    security: SecurityModule,
    onlineBooking: onlineBooking,
    research: research,
    messages: messages,
    news: news,
    data: data,
    version: version,
    adminRoutes: adminRoutes,
    generic: generic,
    currentPage: currentPage
  },
  mutations: {
    initialiseStore (state) {
      // Check if the ID exists
      if (localStorage.getItem('store')) {
        if (JSON.parse(localStorage.getItem('store')).version === state.version) this.replaceState(Object.assign(state, JSON.parse(localStorage.getItem('store'))))
      }
    }
  }
})
